import React from "react";
import { Button, Spinner } from "reactstrap";

const BaseButton = ({
  color,
  label,
  type,
  onClick,
  disable,
  className,
  startIcon,
  endIcon,
  size,
  loader,
  children,
}) => {
  return (
    <>
      <Button
        color={color}
        type={type}
        onClick={onClick}
        disabled={disable || loader}
        className={className}
        size={size}
      >
        {loader && <Spinner size="sm" className="me-2" />}
        {startIcon && <span className="me-2">{startIcon}</span>}
        {loader ? "Loading..." : label || children}
        {endIcon && <span className="ms-2">{endIcon}</span>}
      </Button>
    </>
  );
};

export default BaseButton;
